const GlobalContextInitial = {
  theme: 'light',
  language: 'en',
  toggleLanguage: () => null,
  toggleSidenav: () => null
};

export default GlobalContextInitial;
